import React from "react";
import Icon from "../ui/Icon";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const label = this.props.label ?? "This section";
      return (
        <div className="flex flex-col items-center justify-center gap-3 rounded-3xl border border-red-500/30 bg-red-900/10 px-6 py-10 text-center mx-5 my-4">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-red-900/30 border border-red-500/30">
            <Icon name="error" className="text-2xl text-red-300" />
          </span>
          <div className="space-y-1">
            <p className="text-sm font-semibold text-brand-light">{label} crashed</p>
            <p className="text-xs text-brand-light/50 max-w-[240px] mx-auto">
              {this.state.error.message || "An unexpected error occurred."}
            </p>
          </div>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="rounded-xl bg-brand-purple px-4 py-2 text-xs font-semibold text-brand-light hover:bg-brand-purple/80 transition"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
